const shared = {}

export const checkbox = {
    ...shared,
    '& input[type="checkbox"]': {
        '& + svg': {
            alignItems: 'center',
            display: 'none',
            justifyContent: 'center',
            left: '50%',
            marginTop: '-1px',
            pointerEvents: 'none',
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translate(-50%, -50%)',
        },
        '&:checked': {
            '& + svg': {
                color: '$checkboxIconChecked',
                display: 'flex',
            },
            'backgroundColor': '$checkboxBackgroundChecked',
            'backgroundSize': '18px',
            'borderColor': '$checkboxBorderChecked',
        },
        '&:disabled': {
            '&:checked': {
                '& + svg': {color: '$checkboxIconCheckedDisabled'},
                'backgroundColor': '$checkboxBackgroundCheckedDisabled',
                'borderColor': '$checkboxBorderCheckedDisabled',
            },
            'backgroundColor': '$checkboxBackgroundDisabled',
            'borderColor': '$checkboxBorderDisabled',
            'cursor': 'not-allowed',
            'opacity': 0.5,
        },
        '&:focus-visible:not(:disabled)': {
            '&:checked': {
                '& + svg': {color: '$checkboxIconCheckedFocus'},
                'backgroundColor': '$checkboxBackgroundCheckedFocus',
                'borderColor': '$checkboxBorderCheckedFocus',
            },
            'backgroundColor': '$checkboxBackgroundFocus',
            'borderColor': '$checkboxBorderFocus',
            'outline': '2px solid $checkboxFocusOutline',
        },
        '&:hover:not(:disabled)': {
            '&:checked': {
                '& + svg': {color: '$checkboxIconCheckedHover'},
                'backgroundColor': '$checkboxBackgroundCheckedHover',
                'borderColor': '$checkboxBorderCheckedHover',
            },
            'backgroundColor': '$checkboxBackgroundHover',
            'borderColor': '$checkboxBorderHover',
        },
        'WebkitAppearance': 'none',
        'appearance': 'none',
        'backgroundColor': '$checkboxBackground',
        'borderColor': '$checkboxBorder',
        'borderRadius': '$checkbox',
        'borderStyle': '$checkbox',
        'borderWidth': '$checkbox',
        'cursor': 'pointer',
        'height': '24px',
        'margin': '0',
        'outline': 'none',
        'width': '24px',
    },
    'display': 'flex',
    'marginBottom': '12px',
    'marginTop': '6px',
}

export const inputWrapper = {position: 'relative'}
